import { Anchor } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { TranscriptionMessageTitle } from "../../../TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../../../TranscriptionSubTitle";

import TranscriptionNoSpeechDetectedSvg from "@/assets/transcription_no_speech_detected.svg?react";

export function TranscriptionNoSpeechDetected() {
  const { t } = useTranslation();

  return (
    <>
      <TranscriptionNoSpeechDetectedSvg />
      <TranscriptionMessageTitle>
        {t("no_transcript.no_speech_detected_title")}
      </TranscriptionMessageTitle>
      <TranscriptionSubTitle>
        {t("no_transcript.no_speech_detected_description")}
      </TranscriptionSubTitle>
      <Anchor
        target="_blank"
        href={t("no_transcript.no_speech_detected_link")}
        className="text-sm font-medium"
      >
        {t("learn_more")}
      </Anchor>
    </>
  );
}
